import { BillingSubscription } from './billing-subscription';
import { BillingCurrency } from './billing-currency';
import { BillingRestrictions } from './billing-restrictions';
import { SubscriptionTier } from './subscription-tier';
import { BillingServiceProvider } from './billing-service-provider';

export class Billing {
    public id: string;
    public owner_id: string;
    public currency: BillingCurrency;
    public balance: number;
    public email: string;
    public first_name: string;
    public last_name: string;
    public tax_id: string;
    public address: any;
    public payment_sources: any[];
    public subscriptions: BillingSubscription[];
    public notices: any[];
    public last_payment_at: string;
    public last_payment_value: number;
    public restrictions: BillingRestrictions;
    public tier: SubscriptionTier;
    public service_provider: BillingServiceProvider;
}
